import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { smoothlyMenu } from 'app/app.helpers';
import { alert, confirm } from 'devextreme/ui/dialog';
import validationEngine from 'devextreme/ui/validation_engine';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppInformationService, PortalService } from '../../core/core.module';
import { PortalAchConfirmationDialogComponent } from '../portal-ach-confirmation-dialog/portal-ach-confirmation-dialog.component';
declare var jQuery: any;

@Component({
    selector: 'app-portal-ach',
    templateUrl: './portal-ach.component.html',
    styleUrls: ['./portal-ach.component.scss'],
    standalone: false
})
export class PortalAchComponent implements OnInit {
    @Input() achInfo: any;
    @Input() displayMode: boolean;
    achForm: any = {};
    error: string;
    accountTypes = ['Checking', 'Savings'];
    screenHeight: number;
    screenWidth: number;
    ready = false;
    showDecline = false;
    manualFormEnabled = false;

    get submitted() {
        return this.achInfo.Approved ?? this.achInfo.Declined ?? this.achInfo.ManualFormSelected;
    }

    get readOnly() {
        return this.achInfo.ReadOnly;
    }

    constructor(private route: ActivatedRoute, private appInfo: AppInformationService, private portalService: PortalService, private modalService: BsModalService) {
        this.getScreenSize();
    }
    toggleNavigation(): void {
        jQuery('body').toggleClass('mini-navbar');
        smoothlyMenu();
    }

    @HostListener('window:resize', ['$event'])
    getScreenSize(event?) {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
        // console.log(this.screenHeight, this.screenWidth);
    }

    async ngOnInit() {
        this.achForm.code = this.route.snapshot.params.id;
        this.appInfo.pleaseWaitShow();
        try {
            await this.getData();
        } catch (error) {
            console.log(error);
        }
        this.appInfo.pleaseWaitHide();
        if (this.screenWidth > 850 && !this.displayMode) this.toggleNavigation();
        this.ready = true;
    }

    async getData() {
        const results = await this.portalService.getAchInfo(this.achForm.code);
        if (!results.success) this.error = results.message;
        else {
            this.achInfo = results.value;
            this.manualFormEnabled = this.achInfo.ManualFormEnabled;
        }
    }

    async approve() {
        const success = this.valid('approveValidationGroup');
        if (!success) return;

        const modalRef = this.modalService.show(PortalAchConfirmationDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                ach: this.achForm,
                message: this.achInfo.Message,
                message2: this.achInfo.Message2,
                feeMessage: this.achInfo.FeeMessage
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                this.appInfo.pleaseWaitShow();
                const response = await this.portalService.approveAch(this.achForm);
                if (!response.success)
                    await alert(
                        `Unable to process ACH Confirmation. ${response.message}`,
                        'Unable To Process Confirmation'
                    );
                else {
                    this.achInfo.Approved = new Date();
                    this.achInfo.ApprovedBy = this.achForm.approvedBy;
                }
                this.appInfo.pleaseWaitHide();
            }
            modalRef.hide();
        });
    }

    toggleShowDecline() {
        this.showDecline = !this.showDecline;
    }

    async decline() {
        const valid = this.valid('declineValidationGroup');
        if (!valid) return;

        const success = await confirm('Are you sure you want to decline this ACH form authorization?', 'Are you sure?');
        if (!success) return;

        const response = await this.portalService.declineAch(this.achForm.code, this.achForm.declineReason);
        if (!response.success) await alert('Could not decline ACH. Please refresh and try again.', 'Error');

        this.achInfo.Declined = new Date();
        this.achInfo.DeclineReason = this.achForm.declineReason;
    }

    async submittedManually() {
        const success = await confirm(
            'Are you sure you want to submit the form manually? Orders will not be placed until paperwork is received and funds have been withdrawn.',
            'Continue?'
        );
        if (!success) return;

        const response = await this.portalService.submittedManually(this.achForm.code);
        if (!response.success) await alert('Could not submit the form manually. Please refresh and try again.', 'Error');

        this.achInfo.ManualFormSelected = new Date();
    }

    async printAchForm() {
        const response = await this.portalService.isAchValid(this.achForm.code);
        if (!response.success) {
            this.notify(`${response.message}. Cannot print ach form.`);
            return;
        }

        await this.portalService.printAchForm(this.achForm.code);
    }

    notify(message: string) {
        this.appInfo.notifyToast(message, 'error', 2500, { my: 'center top', at: 'center top', offset: '0 0', of: 'header' });
    }

    valid(validationGroup: 'approveValidationGroup' | 'declineValidationGroup') {
        const groupConfig = validationEngine.getGroupConfig(validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(validationGroup);
            return result.isValid;
        }
        return true;
    }

    validateNumber = (e: any) => {
        const value = e.value;
        return !value || !isNaN(value);
    };

        validateNumberLength = (e: any) => {
        const value = e.value;
        return value.length === 9;
    };
}
